module.exports = __webpack_public_path__ + "img/bg3.587f354b.png";